import React, {useContext, useState} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import './App.css';
import {LinkName} from "./components/UiParts/TopNav";
import {AppContext} from "./components/state/ContextProvider";
import {Simulation} from "./components/Simulation/Simulation";
import {RuleType} from "./components/Simulation/RuleType";

const App: React.FC = () => {
  const [selectedPage, setSelectedPage] = useState<LinkName>('中等部：ヤング');
  const {userInfo, userService} = useContext(AppContext);
  
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<Simulation selectedPage={selectedPage} setSelectedPage={setSelectedPage} rule={RuleType.young} />}
        />
        <Route
          path="/jr"
          element={<Simulation selectedPage={selectedPage} setSelectedPage={setSelectedPage} rule={RuleType.junior} />}
        />
        <Route
          path="/ls"
          element={<Simulation selectedPage={selectedPage} setSelectedPage={setSelectedPage} rule={RuleType.littleSenior} />}
        />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
